export const colors = {
  primary: "#FFD360",
  primaryBackground: "#F6F9FC",
  secondary: "#6064C3",
  secondaryBackground: "#F9F0FF",
  accentDasar: "#06CDCD",
  accentMadya: "#2D71CC",
  accentUtama: "#82108C",
  contentWhite: "#F9F9F9",
  contentBlack100: "#0F1020",
  contentBlack80: "#2E304C",
  contentBlack60: "#5E5F6F",
  contentBlack40: "#9E9EAC",
  contentBlack20: "#C1C1CB",
  defaultGrey: "#DCDCDC",
  elevation: "#F3F3F3",
  warningMain: "#CCC408",
  successMain: "#548C2F",
  successBackground: "#EBF4E5",
  errorMain: "#E2483D",
  errorBackground: "#FED5D5",
  outlinePrimary: "#828282",
  outlineSecondary: "#DCDCDC",
  successAlternative: "#c7e3b5",

  // Neutral Colors
  neutral900: "#1C1C1C",
  neutral800: "#2C363C",
  neutral700: "#5F737F",
  neutral600: "#566B75",
  neutral500: "#5F737F",
  neutral400: "#97AAB3",
  neutral300: "#BBC7CD",
  neutral200: "#E1E8EB",
  neutral100: "#F7F9FC",
  white: "#FFFFFF",

  // Blue - Primary
  primary900: "#001B3F",
  primary800: "#003064",
  primary700: "#00468D",
  primary600: "#005AA9",
  primary500: "#097BDF",
  primary400: "#349BFF",
  primary300: "#72B9FF",
  primary200: "#90C8FF",
  primary100: "#AFD8FF",
  primary50: "#CDE7FF",

  // Cyan - Informative
  cyan900: "#001B3F",
  cyan800: "#004A57",
  cyan700: "#006E82",
  cyan600: "#0093AE",
  cyan500: "#00B8D9",
  cyan400: "#33C6E2",
  cyan300: "#66D5E8",
  cyan200: "#99E3F0",
  cyan100: "#CCF1F7",
  cyan50: "#DDF4F8",

  // Yellow - Warning
  warning900: "#694504",
  warning800: "#8D6900",
  warning700: "#A37F0D",
  warning600: "#DA9C02",
  warning500: "#FFB519",
  warning400: "#FFC916",
  warning300: "#FFD360",
  warning200: "#FFE384",
  warning100: "#FFE384",
  warning50: "#FDF2CA",
  warning25: "#FBF5E7",

  // Red - Error
  error900: "#5D1F1A",
  error800: "#AE2E24",
  error700: "#C9372C",
  error600: "#E2483C",
  error500: "#F25B50",
  error400: "#F87168",
  error300: "#FD9891",
  error200: "#FFD5D2",
  error100: "#FFECEA",
  error50: "#FFF5F5",

  // Green - Success
  success900: "#0C2419",
  success800: "#174832",
  success700: "#206C4C",
  success600: "#2B8F65",
  success500: "#35B37E",
  success400: "#5EC298",
  success300: "#86D1B2",
  success200: "#AFE1CB",
  success100: "#D7F0E5",
  success50: "#E5F6EE",

  // Esarpras Colors
  brandRed: "#FF5656",
  brandGreen: "#0CDF09",
  brandYellow: "#E5C300",
  backgroundFly: "#E1E1E1",
};

export const StatusColorsSuratMasuk = {
  DRAFT: "bg-gray-50 text-gray-600",
  DIKIRIM: "bg-blue-50 text-blue-600",
  DIBACA: "bg-green-50 text-green-600",
  DISPOSISI: "bg-orange-50 text-orange-600",
  DIDISPOSISI: "bg-purple-50 text-purple-600",
  DIARSIPKAN: "bg-gray-200 text-gray-600",
  DITOLAK: "bg-red-50 text-red-600",
};
